import React from 'react';
import LegalDocLayout from '../../components/ChinaDolphins/LegalDocLayout/LegalDocLayout';

const TOC = [
  { id: 'nature-of-service', label: '1. Nature of the Service & Legal Standing' },
  { id: 'order-aggregation', label: '2. Order Aggregation & MOQ' },
  { id: 'failed-pools', label: '3. Failed Pools, Cancellations & Refunds' },
  { id: 'product-liability', label: '4. Product Liability, Customs & Importation' },
  { id: 'anti-circumvention', label: '5. Anti-Circumvention' },
  { id: 'governing-law', label: '6. Governing Law' },
];

export const TermsOfServiceContent = () => (
  <div>
    <p>
      Welcome to <strong>ChinaDolphins</strong>. This Terms of Service Agreement constitutes a legally
      binding agreement between the Buyer or User (&quot;Buyer&quot;) and <strong>MTN GLOBAL LIMITED</strong>,
      operating under the laws of Hong Kong.
    </p>
    <p>
      By registering an account, using ChinaDolphins services, participating in Order Aggregation, or
      completing transactions through the Platform, the Buyer agrees to the following terms.
    </p>

    <h2 id="nature-of-service">1. Nature of the Service &amp; Legal Standing</h2>
    <h3>1.1 Digital Marketplace Status</h3>
    <p>
      The Buyer acknowledges that MTN GLOBAL LIMITED operates a digital B2B technology and marketplace platform connecting global buyers, verified local sourcing agents, and manufacturing factories. ChinaDolphins is not a bank, escrow agent, or financial payment institution. All payment transactions, authorizations, and refunds are handled through approved, regulated third-party payment providers.
    </p>
    <h3>1.2 No Possession of Goods or Financial Custody</h3>
    <p>
      The Platform does not itself manufacture, own, store, transport, take physical custody of products displayed by Manufacturing Partners, or hold financial custody of buyer funds.
    </p>
    <h3>1.3 Independent Participants</h3>
    <p>
      Manufacturing, product specifications, sourcing operations, inspections, and related commercial responsibilities involve the applicable Factory and/or assigned Sourcing Agent.
    </p>

    <h2 id="order-aggregation">2. Order Aggregation &amp; MOQ</h2>
    <h3>2.1 Pooling Mechanism</h3>
    <p>
      ChinaDolphins provides an Order Aggregation Engine allowing multiple Buyers to combine purchasing quantities in order to reach a Factory&apos;s Minimum Order Quantity (MOQ).
    </p>
    <h3>2.2 Conditional Aggregation</h3>
    <p>
      An aggregated production opportunity remains conditional upon the combined participating quantity reaching the Factory&apos;s required MOQ within the applicable aggregation period.
    </p>

    <h2 id="failed-pools">3. Failed Pools, Cancellations &amp; Refunds</h2>
    <p>
      If an aggregation fails to achieve the required MOQ within the designated period, it may close as unfulfilled.
    </p>
    <p>
      Where Buyer funds have already been authorized or collected under the applicable payment workflow, refund processing will be handled through the approved third-party payment provider according to its payment and refund procedures. The Buyer acknowledges that international payment costs, foreign-exchange differences, bank fees, and similar third-party costs may be outside the Platform&apos;s control.
    </p>

    <h2 id="product-liability">4. Product Liability, Customs &amp; Importation</h2>
    <p>
      The Buyer is responsible for determining whether the purchased goods comply with the laws, certifications, import requirements, duties, and taxes applicable in the destination country.
    </p>
    <p>
      Quality disputes are handled using the ChinaDolphins dispute-resolution workflow. The Buyer acts as the <strong>Importer of Record</strong> in the destination country unless another arrangement has been explicitly agreed in writing.
    </p>

    <h2 id="anti-circumvention">5. Anti-Circumvention</h2>
    <p>
      The Buyer agrees not to bypass ChinaDolphins by attempting to establish unauthorized direct commercial relationships, payments, or communications with Factories or Sourcing Agents introduced through the Platform.
    </p>
    <p>
      Violation of anti-circumvention rules may result in immediate suspension or permanent termination of Platform access and potential legal remedies.
    </p>

    <h2 id="governing-law">6. Governing Law</h2>
    <p>
      This agreement identifies <strong>Hong Kong</strong> as the governing jurisdiction for the Platform relationship, subject to applicable law and final legal review.
    </p>
  </div>
);

const TermsOfServicePage = () => {
  return (
    <LegalDocLayout
      title="Global Buyer Terms of Service & Transactional Agreement"
      subtitle="Comprehensive commercial, aggregation, and transactional rules for global buyers on ChinaDolphins."
      effectiveDate="January 1, 2026"
      lastUpdated="August 13, 2026"
      jurisdiction="Hong Kong (MTN GLOBAL LIMITED)"
      tocItems={TOC}
    >
      <TermsOfServiceContent />
    </LegalDocLayout>
  );
};

export const TOS_ASSET_NAME = 'terms-of-service';
export const TermsOfServicePageComponent = TermsOfServicePage;
export default TermsOfServicePage;
